import styles from "./styles.module.css";
import { DatabaseValue } from "../../../contexts/database";
import { UserValue } from "../../../contexts/user";
import { AppValue, AppDisbatch } from "../../../contexts/app";
import { getRolePermissions, updatePermissions, deleteRole } from "../../../utils/databaseactions";
import { useState, useContext, useEffect } from "react";
import Modal from "../../../modal";
import { MdClose } from "react-icons/md";
import { useParams } from "react-router-dom";
import { useQuery } from 'react-query';
import compare from "../../../utils/compare";

export default function Roles({ open, active, setActive }) {
  const context = useContext(AppValue);
  const disbatch = useContext(AppDisbatch);
  const tables = useContext(DatabaseValue);
  const user = useContext(UserValue);
  const [newName, setNewName] = useState("");
  const [role, setRole] = useState("");
  const [updatedData, setUpdatedData] = useState(null);
  const [hasUpdate, setHasUpdate] = useState(false);
  const [fnIsRunning, setFnIsRunning] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { appId } = useParams();

  const { data, error, isLoading, isError, refetch } = useQuery(["roleData", active], () => {
    if (!active) return null;
    const response = getRolePermissions(appId, active, user);
    return response
    .then(results => {
      console.log(results);
      if (!results) throw {err: "results is undefined or null"};
      if (results.err) throw new Error(results.err);
      const tableIds = results.map(cur => cur.table);

      const sortedData = tables.map(t => {
        let i = tableIds.indexOf(t.id);
        let obj = Object.assign({}, results[i]);
        obj.tableName = t.name;
        return obj;
      });

      return sortedData;
    })
    .catch(err => {
      throw new Error(err);
    });
  }, {staleTime: 120000});

  useEffect(() => {
    if (!isError && !isLoading) {
      setUpdatedData(data);
    }
    else setUpdatedData([]);
  }, [data, isError, isLoading]);

  useEffect(() => {
    if (!open) {
      setRole("");
      setHasUpdate(false);
    }
  }, [open]);

  useEffect(() => {
    setFnIsRunning(false);
    setModalIsOpen(false);
  }, [active]);

  useEffect(() => {
    if (!!active && open) {
      setRole(context.roles[active]);
    }
  }, [active, open, context]);

  useEffect(() => {
    setNewName(role);
  }, [role]);

  useEffect(() => {
    if (!!updatedData) {
      let update = false;
      for (let i = 0; i < updatedData.length; i++) {
        if (!compare(data[i], updatedData[i])) {
          update = true;
          break;
        }
      }
      setHasUpdate(update);
    }
  }, [updatedData]);

  const update = (id, field, val) => {
    let obj = updatedData.map(o => Object.assign({}, o));
    obj.filter(cur => cur._id === id)[0][field] = val;
    setUpdatedData(obj);
  }

  const cancel = () => {
    setUpdatedData(data);
  }

  const save = () => {
    if (!hasUpdate) return;
    const cleanedPermissions = updatedData.map(cur => {
      const obj = Object.assign({}, cur);
      delete obj.tableName;
      delete obj.role;
      delete obj.table;
      return obj;
    });
    setHasUpdate(false);
    updatePermissions(appId, cleanedPermissions, user)
    .then(data => {
      console.log(data);
      refetch();
    })
    .catch(err => {
      console.log(err);
      setUpdatedData(data);
    });
  }

  const changeName = () => {
    if (!active || newName === role) return;
    disbatch({type: "updateRoleName", id: active, name: newName});
  }

  const handleEnter = (e) => {
    if (e.keyCode === 13 || e.keyCode === 9) {
      changeName();
      e.target.blur();
    }
  }

  const handleDelete = () => {
    if (!!active) {
      setFnIsRunning(true);
      deleteRole(appId, active, user)
      .then(data => {
        disbatch({type: "deleteRole", role: data._id});
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => setActive(null));
    }
  }

  const renderTable = () => {
    if (isLoading) {
      return <div>Loading Role Data</div>
    }
    if (isError) {
      return <div>Error: {error}</div>
    }

    return (updatedData || []).map((permission, index) => (
      <PermissionItem 
        key={permission._id || `permission-${index}`} 
        permissions={permission} 
        update={update} />
    ));
  }
  
  if (!open || !active) return null;
  return (
    <div className={styles.paper}>
    <div
      style={{
        width: "-webkit-fill-available",
        margin: "10px 30px"
      }}
    >
        <div id="PAPERCANVAS" className={styles.paperBody}>
          <div className={styles.title}>
            <input 
              className={styles.titleInput} 
              value={newName} 
              onKeyDown={handleEnter}
              onChange={(e) => setNewName(e.target.value)} />
            <div 
              className={styles.deleteButton} 
              onClick={() => setModalIsOpen(true)}
            >Delete</div>
          </div>
          <div className={styles.section}>
            <div className={styles.roleGrid} style={{marginBottom: 15}}>
              <div>Table</div>
              <div>View</div>
              <div>Create</div>
              <div>Update</div>
              <div>Delete</div>
            </div>
            {renderTable()}
          </div>
          <div className={styles.section}>
            <button 
              disabled={!hasUpdate} 
              className={`${styles.cancel} ${(!hasUpdate) ? styles.disabled : ""}`}
              onClick={cancel}
            >Cancel</button>
            <button 
              disabled={!hasUpdate} 
              className={`${styles.cancel} ${(!hasUpdate) ? styles.disabled : ""}`}
              onClick={save}
            >Save</button>
          </div>
          <Modal open={modalIsOpen} onClose={() => setModalIsOpen(false)}>
            <div className={styles.form}>
              {fnIsRunning ? (
                <div className={styles.formContainer}>
                  <div className={styles.text}>
                    Deleting {role} Role
                  </div> 
                </div> 
                ) : (
                <>
                  <div className={styles.formTitle}>
                    Delete Role{" "}
                    <MdClose onClick={() => setModalIsOpen(false)} className="icon" />
                  </div>
                  <div className={styles.formContainer}>
                    <div className={styles.text} style={{textAlign: "center", marginBottom: 15}}>
                      Are you sure you? This can't be undone...
                    </div>
                    <button className={styles.save} onClick={handleDelete}>Yes, delete {role} role</button>
                    <button className={styles.clear} onClick={() => setModalIsOpen(false)}>Cancel</button>
                  </div>
                </>
              )}
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
}

const PermissionItem = ({ permissions, update }) => {
  const [view, setView] = useState(false);
  const [create, setCreate] = useState(false);
  const [_update, setUpdate] = useState(false);
  const [_delete, setDelete] = useState(false);

  const handleChange = (e) => {
    switch (e.target.name) {
      case "view":
        setView(e.target.checked);
        break;
      case "create":
        setCreate(e.target.checked);
        break;
      case "update":
        setUpdate(e.target.checked);
        break;
      case "delete":
        setDelete(e.target.checked);
        break;
      default:
        break;
    }
    update(permissions._id, e.target.name, e.target.checked);
  }

  useEffect(() => {
    if (!!permissions) {
      setView(permissions.view);
      setCreate(permissions.create);
      setUpdate(permissions.update);
      setDelete(permissions.delete);
    }
  }, [permissions]);

  return (
    <div className={styles.roleGrid}>
      <div>{permissions.tableName}</div>
      <input onChange={handleChange} type="checkbox" name="view" checked={view} />
      <input onChange={handleChange} type="checkbox" name="create" checked={create} />
      <input onChange={handleChange} type="checkbox" name="update" checked={_update} />
      <input onChange={handleChange} type="checkbox" name="delete" checked={_delete} />
    </div>
  )
}